import { render } from "./QueueDetails.vue?vue&type=template&id=7c27f688&scoped=true"
import script from "./QueueDetails.vue?vue&type=script&lang=js"
export * from "./QueueDetails.vue?vue&type=script&lang=js"

import "./QueueDetails.vue?vue&type=style&index=0&id=7c27f688&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c27f688"]])

export default __exports__